import requests from 'api/requests';
import React, { useCallback, useEffect } from 'react';
import RequestStatusForm from './form';
import StatusList from './statusList';
import { IDriverRequestStatus } from './types';
import useStatuses from './useStatuses';

interface IProps {
  requestID?: number;
  onStatusChange: () => void;

  newStatusInstance: IDriverRequestStatus | null;
  onChangeNewStatusInstance: (statusInstance: IDriverRequestStatus | null) => void;
  addNewStatus: (statusInstance: IDriverRequestStatus) => Promise<any>;
}

export default function RequestStatus(props: IProps) {
  const {
    onStatusChange
  } = props;
  const [statuses, setStatuses] = React.useState<IDriverRequestStatus[] | null>(null);
  const statusTypes = useStatuses();

  const load = useCallback(() => {
    if (!props.requestID) return;

    requests.getAll('/admin/driver/request/status/', {
      request: props.requestID
    }).then((r) => {
      setStatuses(r.body.results);
    })

  }, [props.requestID])

  useEffect(() => load(), [load]);

  const reload = useCallback(() => {
    load();
    onStatusChange();
  }, [load, onStatusChange])

  useEffect(() => {
    document.addEventListener("DriverRequestStatus", reload);
    return () => {
      document.removeEventListener("DriverRequestStatus", reload)
    }
  }, [reload])

  return (
    <div>

      <RequestStatusForm
        requestID={props.requestID}
        statusTypes={statusTypes || []}
        onCreated={reload}
        newStatusInstance={props.newStatusInstance}
        onChangeNewStatusInstance={props.onChangeNewStatusInstance}
        addNewStatus={props.addNewStatus}
      />

      {props.requestID ? (
        <StatusList
          statusTypes={statusTypes || []}
          statuses={statuses}
        />
      ) : null}
    </div>
  );
}